module.exports = __webpack_public_path__ + "img/buzzloading.e5954abe.svg";